module.exports = __webpack_public_path__ + "img/elephant.df850f7.png";